module.exports = __webpack_public_path__ + "media/img/masks/assets-mask-a386c5e45c170cfca4bcea994e7d1612.svg";